import React from "react";

const GlobalPayroll = () => {
  return (
    <section className="min-h-screen flex items-center justify-center p-6 pt-16 bg-gray-100">
      <article className="bg-transparent shadow-lg rounded-2xl p-8 w-full max-w-3xl">
        <header className="text-center mb-6">
          <h2 className="text-3xl font-bold text-blue-600">
            Global Payroll & Compliance
          </h2>
        </header>

        <section className="mb-6">
          <p className="text-gray-700">
            <b>Global Payroll & Compliance</b> solutions by <b>Talennect</b>{" "}
            simplify the complexities of managing international payroll,
            taxation, and workforce regulations. We help businesses streamline
            compensation processes, ensure legal compliance, and minimize
            risks—so you can focus on growing your company without
            administrative burdens.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Why Choose Global Payroll & Compliance?
          </h3>
          <p className="text-gray-700">
            Expanding into new markets or managing a global workforce comes with
            payroll complexities and compliance challenges. Our{" "}
            <b>comprehensive payroll management services</b> ensure accurate and
            timely salary disbursement while adhering to local tax laws and
            labor regulations. With Talennect, you can eliminate payroll errors,
            avoid penalties, and ensure full legal compliance in multiple
            countries.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Our Payroll & Compliance Process
          </h3>
          <p className="text-gray-700">
            We handle every aspect of payroll and compliance with precision. Our
            services include{" "}
            <b>
              salary processing, tax calculations, benefits administration,
              multi-country payroll, and regulatory reporting
            </b>
            . Using advanced payroll technology and a team of compliance
            experts, we ensure your workforce gets paid accurately and on
            time—without the hassle of navigating different tax systems.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Industries We Support
          </h3>
          <p className="text-gray-700">
            Our <b>global payroll and compliance</b> solutions support
            businesses across diverse industries, including{" "}
            <b>IT, finance, healthcare, engineering, and manufacturing</b>.
            Whether you have remote employees, contract workers, or full-time
            staff across multiple locations, we provide tailored payroll
            solutions that ensure compliance and efficiency.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-blue-600">
            Partner with Talennect for Hassle-Free Payroll Management
          </h3>
          <p className="text-gray-700">
            Stay ahead of compliance risks and ensure smooth payroll operations
            with <b>Talennect’s expert payroll and compliance services</b>. Let
            us handle the complexities while you focus on scaling your business.
            Contact us today to learn how our <b>global payroll solutions</b>{" "}
            can support your workforce needs.
          </p>
        </section>
      </article>
    </section>
  );
};

export default GlobalPayroll;
